import type { FaireProductEntity } from "../../entity_types/product";

export const p_bze2zrj7pp: FaireProductEntity = {
  token: "p_bze2zrj7pp",
  type: "product",
  name: "BOY MOM Bracelet – Mothers Gift, Word Jewelry, Motherhood",
  brandToken: "b_v9th4ehh4b",
  brandName: "Two and Crew - Faith Based Jewelry & Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/7ba0838d4e1ad5b89e4a9ce64b8ace7d92ed67a7ea3d1bb06f77a2611bee7513.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc384463c4d2d070ea75f8beb54e9e8673bd6ca18889313e42790d7451cd8cc5.jpeg",
    "https://cdn.faire.com/fastly/daf2b0998c91f82122a7dc4769e70c11e5c028d49c789abfe1e7c968eb503b9e.jpeg",
    "https://cdn.faire.com/fastly/71b27f3a06083dd25019ef60d411c2c9eb501be88ec74ab59f49644355119be6.jpeg",
    "https://cdn.faire.com/fastly/f349de4eed56ce5e304eab31b5d705ec5ddb9c1198903da62938ec9f8fb167a7.jpeg",
    "https://cdn.faire.com/fastly/90b3264cf99a66fe27ce373d2fe3888cf515cfa894275f76bde6a05392a2c31c.jpeg",
    "https://cdn.faire.com/fastly/c90ad8159d013d896fa8c51136b2a1f0c17f5435f1383717769fa71de5ab4707.jpeg",
    "https://cdn.faire.com/fastly/ec6f76059be88164ac325426cd1d045be3350366c309489023f755728f4c3b7b.jpeg",
  ],
  priceDollars: 6.83,
  description:
    "Celebrate the joy of raising boys with this BOY MOM Beaded Stretch Bracelet. Designed with classic white pearl beads and accented by sleek black letter beads with shimmering gold lettering, this bracelet makes a bold yet elegant statement. The stretch design ensures all-day comfort and easy wear, making it perfect for everyday style or stacking with other inspirational bracelets.\n\nEach bracelet comes beautifully packaged on a custom card that reads: “Raising beautiful, strong, powerful humans” — making it a meaningful keepsake or thoughtful gift for moms of boys.\n\nProduct Details\n\n- Adult-sized stretch bracelet for a comfortable fit\n\n- Timeless pearl beads paired with black and gold letter beads\n\n- Gold lettering spells BOY MOM\n\n- Packaged on a keepsake card with inspirational message\n\n- Lightweight, stackable, and easy to wear daily\n\nPerfect as a Mother’s Day gift, birthday gift, new mom gift, or everyday jewelry piece for proud boy moms.",
  tags: [],
  msrpDollars: 21.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:40.550Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
